import { STORAGE_KEY, sanitizeProfile, type PlayerProfile } from './model';
import type { ProgressRepository } from './repository';

export class LocalStorageProgressRepository implements ProgressRepository {
  readonly kind = 'local' as const;

  async load(): Promise<PlayerProfile> {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return sanitizeProfile(null);
    try {
      return sanitizeProfile(JSON.parse(raw));
    } catch {
      return sanitizeProfile(null);
    }
  }

  async save(profile: PlayerProfile): Promise<void> {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
  }

  async reset(): Promise<void> {
    localStorage.removeItem(STORAGE_KEY);
  }
}
